import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=855bd53e"
import script from "./app-header.vue?vue&type=script&lang=js"
export * from "./app-header.vue?vue&type=script&lang=js"
import style0 from "./app-header.vue?vue&type=style&index=0&id=855bd53e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports